import { createContext } from "react";
import { defaultInternationalizationState, InternationalizationState } from 'services/shared/Internationalization'

const InternationalizationContext = createContext<InternationalizationState>(defaultInternationalizationState);
export default InternationalizationContext;